/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SendEnterpriseAdminOnboardingEmailRequestBody,
  SendEnterpriseAdminOnboardingEmailRequestBody$Outbound,
  SendEnterpriseAdminOnboardingEmailRequestBody$outboundSchema,
} from "../components/sendenterpriseadminonboardingemailrequestbody.js";

export type SendEnterpriseAdminOnboardingEmailSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SendEnterpriseAdminOnboardingEmailRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  sendEnterpriseAdminOnboardingEmailRequestBody:
    SendEnterpriseAdminOnboardingEmailRequestBody;
};

/** @internal */
export type SendEnterpriseAdminOnboardingEmailSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SendEnterpriseAdminOnboardingEmailSecurity$outboundSchema:
  z.ZodMiniType<
    SendEnterpriseAdminOnboardingEmailSecurity$Outbound,
    SendEnterpriseAdminOnboardingEmailSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function sendEnterpriseAdminOnboardingEmailSecurityToJSON(
  sendEnterpriseAdminOnboardingEmailSecurity:
    SendEnterpriseAdminOnboardingEmailSecurity,
): string {
  return JSON.stringify(
    SendEnterpriseAdminOnboardingEmailSecurity$outboundSchema.parse(
      sendEnterpriseAdminOnboardingEmailSecurity,
    ),
  );
}

/** @internal */
export type SendEnterpriseAdminOnboardingEmailRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SendEnterpriseAdminOnboardingEmailRequestBody:
    SendEnterpriseAdminOnboardingEmailRequestBody$Outbound;
};

/** @internal */
export const SendEnterpriseAdminOnboardingEmailRequest$outboundSchema:
  z.ZodMiniType<
    SendEnterpriseAdminOnboardingEmailRequest$Outbound,
    SendEnterpriseAdminOnboardingEmailRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      sendEnterpriseAdminOnboardingEmailRequestBody:
        SendEnterpriseAdminOnboardingEmailRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        sendEnterpriseAdminOnboardingEmailRequestBody:
          "SendEnterpriseAdminOnboardingEmailRequestBody",
      });
    }),
  );

export function sendEnterpriseAdminOnboardingEmailRequestToJSON(
  sendEnterpriseAdminOnboardingEmailRequest:
    SendEnterpriseAdminOnboardingEmailRequest,
): string {
  return JSON.stringify(
    SendEnterpriseAdminOnboardingEmailRequest$outboundSchema.parse(
      sendEnterpriseAdminOnboardingEmailRequest,
    ),
  );
}
